<template>
  <Header />
  <div class="game-container">
    <Figure :wrong-count="wrongLetters.length" />
    <WrongLetters :wrong-letters="wrongLetters" />
    <Word :letters="letters" :correct-letters="correctLetters" />
  </div>
  <Popup :status="status" :word="word" @reset="reset" />
  <Notification :show="notification" />
</template>

<script>
import { computed, ref } from "vue"
import Header from "@/components/hangman/Header"
import Figure from "@/components/hangman/Figure"
import WrongLetters from "@/components/hangman/WrongLetters"
import Word from "@/components/hangman/Word"
import Popup from "@/components/hangman/Popup"
import Notification from "@/components/hangman/Notification"
import onKeydown from "@/assets/onKeydown"
const words = ["acne", "allergy", "appendiciti", "amnesia", "arthritis", "asthma", "backache", "bleeding", "blind", "cancer", "cold", "cough"]
const randomWord = () => words[Math.floor(Math.random() * words.length)]
export default {
  components: { Header, Figure, Word, WrongLetters, Popup, Notification },
  setup() {
    const word = ref(randomWord())
    const guessedLetters = ref([])
    const letters = computed(() => word.value.split(""))
    const wrongLetters = computed(() => guessedLetters.value.filter((l) => !letters.value.includes(l)))
    const correctLetters = computed(() => guessedLetters.value.filter((l) => letters.value.includes(l)))
    const status = computed(() => {
      if (wrongLetters.value.length === 8) return "lose"
      if (letters.value.every((l) => correctLetters.value.includes(l))) return "win"
      return ""
    })
    const reset = () => {
      guessedLetters.value = []
      word.value = randomWord()
    }
    const notification = ref(false)
    const showNotification = () => {
      notification.value = true
      setTimeout(() => (notification.value = false), 2000)
    }
    onKeydown((event) => {
      const letter = event.key.toLowerCase()
      if (event.keyCode < 65 || event.keyCode > 90) return
      if (status.value) return
      if (guessedLetters.value.includes(letter)) {
        showNotification()
        return
      }
      guessedLetters.value.push(letter)
    })
    return {
      letters,
      word,
      wrongLetters,
      correctLetters,
      guessedLetters,
      notification,
      status,
      reset,
    }
  },
}
</script>

<style scoped>
.game-container {
  padding: 20px 30px;
  position: relative;
  margin: auto;
  height: 350px;
  width: 450px;
}
</style>
